/** A look, not a stored kind: a message is `communications`, a voice note an `input_mode`. */
export const KIND_LOOKS = [
    'site_visit', 'meeting', 'task', 'block', 'sms', 'email', 'note', 'voice_note', 'call',
];
export const KIND_STYLES = {
    site_visit: { label: 'Site visit', icon: 'pin', fg: '#2e7d4f', bg: '#e5f1e9' },
    meeting: { label: 'Meeting', icon: 'people', fg: '#2b66a8', bg: '#e3edf9' },
    task: { label: 'Task', icon: 'check_square', fg: '#b0731a', bg: '#fbf0dc' },
    block: { label: 'Time block', icon: 'clock', fg: '#6f6e68', bg: '#efeee9' },
    sms: { label: 'Text', icon: 'bubble', fg: '#1f8a8a', bg: '#e1f2f2' },
    email: { label: 'Email', icon: 'envelope', fg: '#2b66a8', bg: '#e3edf9' },
    note: { label: 'Note', icon: 'pencil', fg: '#6f6e68', bg: '#efeee9' },
    voice_note: { label: 'Voice note', icon: 'mic', fg: '#6f6e68', bg: '#efeee9' },
    call: { label: 'Call', icon: 'phone', fg: '#7a4fb0', bg: '#eee7f8' },
};
/** The look of a stored activity (a voice note is a note made by voice). */
export function lookOfActivity(kind, inputMode = 'typed') {
    if (kind === 'appointment')
        return 'site_visit';
    if (kind === 'note' && inputMode === 'voice')
        return 'voice_note';
    return kind;
}
// ---------------------------------------------------------------------------
// Time blocks (Aaron, point 7 — never *personal* blocks)
// ---------------------------------------------------------------------------
export const BLOCK_TYPES = ['lunch', 'office', 'travel', 'time_off', 'other'];
export const BLOCK_TYPE_LABELS = {
    lunch: 'Lunch',
    office: 'Office',
    travel: 'Travel',
    time_off: 'Time off',
    other: 'Other',
};
/** A block's title: its type, or *Office · quotes* with its note. */
export function blockTitle(type, note) {
    const words = note?.trim();
    return words ? `${BLOCK_TYPE_LABELS[type]} · ${words}` : BLOCK_TYPE_LABELS[type];
}
// ---------------------------------------------------------------------------
// Reminders, repeats, people
// ---------------------------------------------------------------------------
/** §8.2's Reminder, in minutes before; null is *None* (§19 B31). */
export const REMINDER_OPTIONS = [
    { minutes: null, label: 'None' },
    { minutes: 0, label: 'At the time' },
    { minutes: 5, label: '5 min before' },
    { minutes: 15, label: '15 min before' },
    { minutes: 30, label: '30 min before' },
    { minutes: 60, label: '1 hour before' },
    { minutes: 1440, label: '1 day before' },
];
/** `every_other_week`: a meeting's *Every other week* (§9.6, migration 0136). */
export const REPEAT_RULES = ['daily', 'weekly', 'every_other_week', 'monthly', 'yearly'];
/** A task's Repeats (§8.2). */
export const TASK_REPEAT_OPTIONS = [
    { rule: null, label: 'Never' },
    { rule: 'daily', label: 'Every day' },
    { rule: 'weekly', label: 'Every week' },
    { rule: 'monthly', label: 'Every month' },
    { rule: 'yearly', label: 'Every year' },
];
/** A task or a meeting has at most this many people (D21). */
export const MAX_PARTICIPANTS = 25;
export const TOO_MANY_PEOPLE = 'A task or meeting can have up to 25 people.';
/** A saved group has two to twelve; a task list at most 25 members and 12 buckets (§16). */
export const GROUP_MAX = 12;
export const LIST_MAX_MEMBERS = 25;
export const LIST_MAX_BUCKETS = 12;
/** A timed task's height on the calendar, and its busy time (§19 B16, §6.4.2). */
export const TIMED_TASK_MINUTES = 20;
/**
 * The buckets a new task list starts with. Board 19 C drew a fourth, *Done*,
 * where ticked tasks went; Aaron (Oct 23): buckets aren't statuses, so a
 * finished task stays in its own bucket, under *Completed* (migration 0139).
 */
export const DEFAULT_BUCKETS = ['To bring up', 'This week', 'Waiting on someone'];
/** What a call came to (Board 14 C). */
export const CALL_OUTCOMES = ['Reached', 'Left a voicemail', 'No answer', 'Wrong number'];
//# sourceMappingURL=kinds.js.map